module.exports = __webpack_public_path__ + "img/数据资产(旧).fc426153.svg";